import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/drop-arrow.svg'


const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = {
  key: 2,
  class: "error-wrapper"
}
const _hoisted_3 = { class: "text-tiny emphasis" }
const _hoisted_4 = {
  key: 3,
  class: "loader-spinner-wrapper"
}
const _hoisted_5 = {
  key: 2,
  class: "error-wrapper"
}
const _hoisted_6 = { class: "text-tiny emphasis" }
const _hoisted_7 = {
  key: 3,
  class: "loader-spinner-wrapper"
}

import { SelectableAction } from "@/library/helpers/structureTableColumns";
import { RoomObject } from "@/library/types/room/rooms";
import { ref, h, watch } from "vue";
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
import vSelect from "vue-select";
import LoaderSpinner from "./LoaderSpinner.vue";
export type LocalVueSelectOption = string | object;

export type FilterByOption = LocalVueSelectOption | RoomObject;

type LocalFilterBy = (
  // eslint-disable-next-line no-unused-vars
  option: FilterByOption,
  // eslint-disable-next-line no-unused-vars
  label: string,
  // eslint-disable-next-line no-unused-vars
  search: string
) => boolean;

type CustomSelectProps = {
  customClass?: string;
  options: LocalVueSelectOption[];
  modelValue?: LocalVueSelectOption | number | null;
  label?: string;
  reducedKey?: string | null;
  filterBy?: LocalFilterBy | null;
  value?: LocalVueSelectOption | null;
  placeholder?: string;
  appendToBody?: boolean;
  clearable?: boolean;
  required?: boolean;
  id?: string;
  name?: string;
  closeOnSelect?: boolean;
  keepPlaceholder?: boolean;
  showError?: boolean;
  errorText?: string;
  hasSelectableOptions?: boolean;
  isLoading?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
    customClass: { default: "" },
    options: { default: () => [] },
    modelValue: { default: null },
    label: { default: "" },
    reducedKey: { default: null },
    filterBy: { type: [Function, null], default: null },
    value: { default: null },
    placeholder: { default: "" },
    appendToBody: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    id: { default: "" },
    name: { default: "" },
    closeOnSelect: { type: Boolean, default: true },
    keepPlaceholder: { type: Boolean, default: false },
    showError: { type: Boolean, default: false },
    errorText: { default: "" },
    hasSelectableOptions: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const customSelectProps = __props;
const emit = __emit;

const Deselect = {
  render: () =>
    h("img", {
      src: require("@/assets/img/remove.svg")
    })
};

const localModelValue = ref(
  customSelectProps.keepPlaceholder
    ? customSelectProps.placeholder
    : customSelectProps.modelValue ?? customSelectProps.value
);

watch(
  () => localModelValue.value,
  newValue => {
    if ((typeof newValue === "string" && !newValue.length) || !newValue) {
      emit("update:modelValue", null);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hasSelectableOptions)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!__props.filterBy)
            ? (_openBlock(), _createBlock(_unref(vSelect), {
                key: 0,
                reduce: (option) => __props.reducedKey && typeof option !== 'string'  ? option[__props.reducedKey] : option,
                class: _normalizeClass([__props.customClass, __props.showError && 'warning']),
                options: __props.options,
                components: { Deselect: Deselect },
                label: __props.label,
                modelValue: localModelValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
                value: __props.value,
                "onOption:selected": _cache[1] || (_cache[1] = (option) => {
      if (__props.keepPlaceholder) localModelValue.value = __props.placeholder
      emit('update:modelValue',  __props.reducedKey && typeof option !== 'string' ? option[__props.reducedKey] : option)
      }),
                clearable: __props.clearable,
                placeholder: __props.isLoading ? '' : __props.placeholder,
                "append-to-body": __props.appendToBody,
                required: __props.required,
                id: __props.id,
                name: __props.name,
                closeOnSelect: __props.closeOnSelect
              }, {
                "selected-option": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "selected-option")
                ]),
                "open-indicator": _withCtx(({ attributes }) => [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))], 16)
                ]),
                "list-header": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-header")
                ]),
                option: _withCtx((option) => [
                  _renderSlot(_ctx.$slots, "option", { option: option })
                ]),
                "list-footer": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-footer")
                ]),
                _: 3
              }, 8, ["reduce", "class", "options", "components", "label", "modelValue", "value", "clearable", "placeholder", "append-to-body", "required", "id", "name", "closeOnSelect"]))
            : (_openBlock(), _createBlock(_unref(vSelect), {
                key: 1,
                reduce: (option) => __props.reducedKey && typeof option !== 'string'  ? option[__props.reducedKey] : option,
                class: _normalizeClass([__props.customClass, __props.showError && 'warning']),
                filterBy: __props.filterBy,
                options: __props.options,
                components: { Deselect: Deselect },
                label: __props.label,
                modelValue: localModelValue.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localModelValue).value = $event)),
                value: __props.value,
                "onOption:selected": _cache[3] || (_cache[3] = (option) => {
      if (__props.keepPlaceholder) localModelValue.value = __props.placeholder
      emit('update:modelValue',  __props.reducedKey && typeof option !== 'string' ? option[__props.reducedKey] : option)
      }),
                clearable: __props.clearable,
                placeholder: __props.isLoading ? '' : __props.placeholder,
                "append-to-body": __props.appendToBody,
                required: __props.required,
                id: __props.id,
                name: __props.name,
                closeOnSelect: __props.closeOnSelect
              }, {
                "selected-option": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "selected-option")
                ]),
                "open-indicator": _withCtx(({ attributes }) => [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))], 16)
                ]),
                "list-header": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-header")
                ]),
                option: _withCtx((option) => [
                  _renderSlot(_ctx.$slots, "option", { option: option })
                ]),
                "list-footer": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-footer")
                ]),
                _: 3
              }, 8, ["reduce", "class", "filterBy", "options", "components", "label", "modelValue", "value", "clearable", "placeholder", "append-to-body", "required", "id", "name", "closeOnSelect"])),
          (__props.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(__props.errorText), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(LoaderSpinner)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!__props.filterBy)
            ? (_openBlock(), _createBlock(_unref(vSelect), {
                key: 0,
                reduce: (option) => __props.reducedKey && typeof option !== 'string'  ? option[__props.reducedKey] : option,
                class: _normalizeClass([__props.customClass, __props.showError && 'warning']),
                options: __props.options,
                components: { Deselect: Deselect },
                label: __props.label,
                modelValue: localModelValue.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localModelValue).value = $event)),
                value: __props.value,
                "onOption:selected": _cache[5] || (_cache[5] = (option) => {
      if (__props.keepPlaceholder) localModelValue.value = __props.placeholder
      emit('update:modelValue',  __props.reducedKey && typeof option !== 'string' ? option[__props.reducedKey] : option)
      }),
                clearable: __props.clearable,
                placeholder: __props.isLoading ? '' : __props.placeholder,
                "append-to-body": __props.appendToBody,
                required: __props.required,
                id: __props.id,
                name: __props.name,
                closeOnSelect: __props.closeOnSelect
              }, {
                "selected-option": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "selected-option")
                ]),
                "open-indicator": _withCtx(({ attributes }) => [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))], 16)
                ]),
                "list-header": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-header")
                ]),
                option: _withCtx((option) => [
                  _renderSlot(_ctx.$slots, "option", { option: option })
                ]),
                "list-footer": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-footer")
                ]),
                _: 3
              }, 8, ["reduce", "class", "options", "components", "label", "modelValue", "value", "clearable", "placeholder", "append-to-body", "required", "id", "name", "closeOnSelect"]))
            : (_openBlock(), _createBlock(_unref(vSelect), {
                key: 1,
                reduce: (option) => __props.reducedKey && typeof option !== 'string'  ? option[__props.reducedKey as keyof SelectableAction] : option,
                class: _normalizeClass([__props.customClass, __props.showError && 'warning']),
                filterBy: __props.filterBy,
                options: __props.options,
                components: { Deselect: Deselect },
                label: __props.label,
                modelValue: localModelValue.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localModelValue).value = $event)),
                value: __props.value,
                selectable: (option) => option.selectable,
                "onOption:selected": _cache[7] || (_cache[7] = (option) => {
      if (__props.keepPlaceholder) localModelValue.value = __props.placeholder
      emit('update:modelValue',  __props.reducedKey && typeof option !== 'string' ? option[__props.reducedKey  as keyof SelectableAction] : option)
      }),
                clearable: __props.clearable,
                placeholder: __props.isLoading ? '' : __props.placeholder,
                "append-to-body": __props.appendToBody,
                required: __props.required,
                id: __props.id,
                name: __props.name,
                closeOnSelect: __props.closeOnSelect
              }, {
                "selected-option": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "selected-option")
                ]),
                "open-indicator": _withCtx(({ attributes }) => [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))], 16)
                ]),
                "list-header": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-header")
                ]),
                option: _withCtx((option) => [
                  _renderSlot(_ctx.$slots, "option", { option: option })
                ]),
                "list-footer": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "list-footer")
                ]),
                _: 3
              }, 8, ["reduce", "class", "filterBy", "options", "components", "label", "modelValue", "value", "selectable", "clearable", "placeholder", "append-to-body", "required", "id", "name", "closeOnSelect"])),
          (__props.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(__props.errorText), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(LoaderSpinner)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})